export default "__VITE_ASSET__BZWGO2gA__"